import React from 'react';

import { OnClick } from '@rbilabs/components-library/build/components/button';
import { useIntl } from 'react-intl';

import { ActionButton, ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { useLocationContext } from 'state/location';
import { routes } from 'utils/routing';

interface IProps {
  url?: string;
  onClick?: OnClick;
}

export const MainMenuLink: React.FC<IProps> = ({ url, onClick }) => {
  const { formatMessage } = useIntl();
  const { navigate } = useLocationContext();

  const clickHandler: OnClick = e => (onClick ? onClick(e) : navigate(url || routes.menu));

  return (
    <ActionButton
      onClick={clickHandler}
      size={ActionButtonSizes.SMALL}
      variant={ActionButtonVariants.OUTLINE}
    >
      {formatMessage({ id: 'mainMenu' })}
    </ActionButton>
  );
};
